import React, { useEffect, useState } from "react";
import { Col, Row } from "antd"
import Container from "../../../../Atomics/Container"
import { Widget } from "../../../../Atomics/Widget"
import { useTranslation } from "react-i18next";
import useFetch from "../../../../../../server/useFetch";
import Spinner from "../../../../Atomics/Spinner";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import clsx from 'clsx';
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import { datePeriodsDropdown, energyDa } from "../../dummyData";
import logger from "../../../../../../server/server";
import { useAuthContext } from "../../../../../../contexts/AuthContext";

export const BuildingEnergeticConsumptionDA = ({ building, currentFloor, ...props }) => {
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const { t } = useTranslation();
    const { user, tenant } = useAuthContext();

    useEffect(() => {
        logger.info("User: " + user?.Username + " entered BuildingEnergeticConsumptionDA successfully! Tenant: " + tenant);
    }, []);

    const [datePeriod, setDatePeriod] = useState("Últimos 7 dias");

    // const {
    //     data: datePeriodsDropdownData,
    //     isLoading: datePeriodsDropdownIsLoading,
    //     refetch: refetchDatePeriodsDropdown,
    // } = useFetch("/unified_temporary/datePeriodsDropdown", "datePeriodsDropdown");

    // const {
    //     data: energyConsumptionDAData,
    //     isLoading: energyConsumptionDAIsLoading,
    //     refetch: refetchEnergyConsumptionDA,
    //     isFetching,
    // } = useFetch("/unified_temporary/energyConsumption/dailyAnalysis", "energyConsumptionDA", { buildingId: building?.id, datePeriod: datePeriod, currentFloor: currentFloor });

    // useEffect(() => {
    //     refetchEnergyConsumptionDA();
    // }, [datePeriod, currentFloor])

    return (
        <PageContent className={clsx('building_room_details', props?.className)} data-testid={"building_room_details"}>
            {/* {!isFetching ? ( */}
            <Row gutter={[16, 16]}> {/* Define o layout de linhas com largura total */}
                <Col span={24} style={{ alignContent: 'center' }}>
                    <Row>
                        <Col span={10}>
                            <h3>
                                {building?.name} | {t("Energetic Consumption").toLocaleUpperCase()}
                            </h3>
                        </Col>
                        {/* <Col span={4} offset={10} style={{ alignContent: 'center' }}>
                                <SelectAtomic
                                    optionsData={datePeriodsDropdown}
                                    handleOptionsChange={(value, record) => {
                                        setDatePeriod(value);
                                    }}
                                    defaultValue={datePeriod}
                                    fullWidth={true}
                                />
                            </Col> */}
                    </Row>
                </Col>
                <Col span={6}> {/* Define uma coluna com 12 espaços (metade da linha) */}
                    <Widget
                        data={{
                            background: "white", // Define o fundo como transparente
                            title: t("Average Energy Consumption"), // Título do Widget traduzido
                            icon: null, // Nenhum ícone definido
                            charts: [
                                {
                                    chartType: "bigNumberChart",
                                    chartId: "bigNumberChartOne",
                                    height: '200px',
                                    data: energyDa?.averageEnergyCosnumption ?? [],
                                },
                            ],
                        }}
                    />
                </Col>
                <Col span={6}>
                    <Widget
                        data={{
                            background: "white",
                            title: t("Energy Consumption per user"),
                            icon: null,
                            charts: [
                                {
                                    chartType: 'bigNumberChart',
                                    chartId: 'bigNumberChartOne',
                                    height: '200px',
                                    data: energyDa?.energyConsumptionByUser ?? []
                                }
                            ],
                        }}
                    />
                </Col>
                <Col span={12}>
                    <Widget
                        data={{
                            background: "white",
                            title: t("Consumption per Floor"),
                            icon: null,
                            charts: [
                                {
                                    chartType: 'columnsChartApex',
                                    chartId: 'columnsChartApexOne',
                                    height: '200px',
                                    data: energyDa?.energyConsumptionByFloor ?? []
                                }
                            ],
                        }}
                    />
                </Col>
                <Col span={24}>
                    <Widget
                        data={{
                            background: "white",
                            title: t("Building Energy Consumption Evolution"),
                            icon: null,
                            // dropdowns: [{data: datePeriodsDropdownData, value: datePeriod, functionChange: (value) => setDatePeriod(value)}],
                            charts: [
                                {
                                    chartType: 'mixedLineColumnChartApex',
                                    chartId: 'mixedLineColumnChartApexOne',
                                    height: '220px',
                                    data: energyDa?.evolutionOfBuildingEnergyConsumption ?? [],
                                }
                            ],
                        }}
                    />
                </Col>
            </Row>
            {/* ) : (
                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Spinner stroke="green" />
                </div>
            )} */}
        </PageContent>
    )
}